const CHECK_INTERVAL = 5 * 60 * 1000 // 5 minutos
const DISMISSED_KEY = 'nura:dismissed-build-id'

export const useVersionCheck = () => {
  const updateAvailable = ref(false)
  const config = useRuntimeConfig()
  const currentBuildId = config.public.buildId as string
  const latestServerBuildId = ref<string | null>(null)

  let timer: ReturnType<typeof setInterval> | null = null

  async function check() {
    try {
      const data = await $fetch<{ buildId: string }>('/version.json', {
        cache: 'no-store',
        query: { t: Date.now() },
      })

      latestServerBuildId.value = data.buildId

      if (data.buildId && currentBuildId && data.buildId !== currentBuildId) {
        const dismissed = localStorage.getItem(DISMISSED_KEY)
        if (dismissed !== data.buildId) {
          updateAvailable.value = true
        }
      }
    } catch {
      // Silencioso — não interrompe o usuário se a checagem falhar
    }
  }

  function refresh() {
    window.location.reload()
  }

  function dismiss() {
    updateAvailable.value = false
    if (latestServerBuildId.value) {
      localStorage.setItem(DISMISSED_KEY, latestServerBuildId.value)
    }
  }

  onMounted(() => {
    if (import.meta.dev) return
    timer = setInterval(check, CHECK_INTERVAL)
  })

  onUnmounted(() => {
    if (timer) clearInterval(timer)
  })

  return { updateAvailable, refresh, dismiss }
}
